(() => {
  /**
   * finally callback
   * @param callback
   * @returns {Promise.<>} Promise
   */
  Promise.prototype.finally = function (callback) {
    const P = this.constructor;
    return this.then(
      value => P.resolve(callback()).then(() => value),
      reason => P.resolve(callback()).then(() => {
        throw reason;
      })
    );
  };
})();



// WEBPACK FOOTER //
// ./src/core/promise.js